const DOT_SEPARATED_DATE_TIME =
  /^(\d{2})\.(\d{2})\.(\d{4})(?:[,\s]+(\d{2}):(\d{2})(?::(\d{2}))?)?$/;

export function parseDate(dateString: string) {
  const match = DOT_SEPARATED_DATE_TIME.exec(dateString?.trim?.() ?? '');

  if (!match) {
    return new Date(dateString);
  }

  const [, day, month, year, hours = '0', minutes = '0', seconds = '0'] = match;

  return new Date(
    Number(year),
    Number(month) - 1,
    Number(day),
    Number(hours),
    Number(minutes),
    Number(seconds),
  );
}

export function formatDate(dateString: string) {
  const date = parseDate(dateString);
  const day = date.getDate().toString().padStart(2, '0');
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const year = date.getFullYear().toString();

  return `${day}.${month}.${year}`;
}

/** `YYYY-MM-DD` in the user's local time, e.g. for export file names. */
export function formatIsoDate(date: Date) {
  const day = date.getDate().toString().padStart(2, '0');
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const year = date.getFullYear().toString();

  return `${year}-${month}-${day}`;
}

export function formatDateTime(dateString: string) {
  const formattedDate = formatDate(dateString);

  const date = parseDate(dateString);
  const hour = date.getHours().toString();
  const minute = date.getMinutes().toString().padStart(2, '0');

  return `${formattedDate}, ${hour}:${minute}`;
}

export function formatTime(dateString: string) {
  const date = parseDate(dateString);
  const hour = date.getHours().toString().padStart(2, '0');
  const minute = date.getMinutes().toString().padStart(2, '0');

  return `${hour}:${minute}`;
}
